import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { explainSteps, teachingFormula } from '../data/benefits';
export function VisualExplain() {
  return <section className="py-20 px-4 bg-stone-100 border-y border-stone-200" data-id="element-278" data-mp="2uo61wz3bs2fq">
      <div className="max-w-5xl mx-auto text-center" data-id="element-279" data-mp="2zmr5n8hsd48x">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-stone-800" data-id="element-280" data-mp="2znis9ttenrn2">
          Completely Visual Means Easier to Explain
        </h2>
        <p className="text-base md:text-lg text-stone-600 max-w-2xl mx-auto mb-12" data-id="element-281" data-mp="3sb54fqgp84lj">
          Instead of long pages of theory, the system uses visual teaching
          resources to help you explain:
        </p>

        <ul className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-12" data-id="element-282" data-mp="3il3d8pt1u62e">
          {explainSteps.map((step, i) => <motion.li key={`${step.word}-${i}`} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.25,
          delay: i * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-stone-200 rounded-2xl p-5 ${i === explainSteps.length - 1 ? 'col-span-2 md:col-span-1' : ''}`} data-id="element-283" data-mp="a4qs1vy2w2p9" data-mpi={i}>
              <p className="text-2xl font-serif font-bold uppercase text-rose-700 mb-1" data-id="element-284" data-mp="3c1apq0n7e6b6">
                {step.word}
              </p>
              <p className="text-sm text-stone-600" data-id="element-285" data-mp="3m11ju17uqjaq">{step.text}</p>
            </motion.li>)}
        </ul>

        <ol className="flex flex-wrap items-center justify-center gap-2 mb-4" data-id="element-286" data-mp="3h1ou98pliy4g">
          {teachingFormula.map((word, i) => <li key={word} className="flex items-center gap-2" data-id="element-287" data-mp="1ro3c9pdje0r3" data-mpi={i}>
              <span className="bg-rose-900 text-white text-xs sm:text-sm font-bold uppercase tracking-wider rounded-full px-4 py-2" data-id="element-288" data-mp="1moqp13ir6rnz">
                {word}
              </span>
              {i < teachingFormula.length - 1 && <ChevronRight size={16} className="text-rose-700" aria-hidden="true" data-id="element-289" data-mp="2gepsd8pznhki" />}
            </li>)}
        </ol>
        <p className="text-2xl font-serif font-bold text-rose-900" data-id="element-290" data-mp="2qdp10rar7d7i">
          That is the system.
        </p>
      </div>
    </section>;
}